<div class="bg-evaluete">
  <h1 class="text-primary-question">Bem Vindo</h1>
  @if (!!questions && questions.length > 0) {
    <app-box-container [questions]="questions" (onFinish)="fetchResults($event)" [done]="answersSent"></app-box-container>
  }
  @if (questions == null || questions.length == 0) {
    <div class="loading-questions">
      Carregando as perguntas...
      <br/>
      <fa-icon [icon]="faSpinner" [spin]="true"></fa-icon>
    </div>
  }
</div>
